<template>
    <div class="page-banner-setting-edit">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">後臺設置</div>
            <div class="breadcrumb-item">版本更新 修改</div>
        </div>
        <div class="pg-block">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>

            <div class="pg-form-wrap">
                <Row>
                    <Col span="20" push="1">
                        <Form>
                            <Row>
                                <Col span="24">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>版本</span>
                                        </div>
                                        <Input v-model="form.version"/>
                                    </FormItem>
									<FormItem>
									    <div slot="label" class="form-label">
									        <em class="red">* </em>
									        <span>Android地址</span>
									    </div>
									    <Input v-model="form.android"/>
									</FormItem>
									<FormItem>
									    <div slot="label" class="form-label">
									        <em class="red">* </em>
									        <span>IOS地址</span>
									    </div>
									    <Input v-model="form.ios"/>
									</FormItem>
									<FormItem>
									    <div slot="label" class="form-label">
									        <em class="red">* </em>
									        <span>更新内容</span>
									    </div>
									    <textarea ref="textValue" v-model="form.describe" value="" class="text-value"></textarea>
									</FormItem>
                                </Col>
                            </Row>

                            <FormItem>
                                <div class="pg-btn-wrap">
                                    <div class="pg-btn style1" @click="handleCheckForm">確認添加</div>
                                    <div class="pg-btn" @click="handleBack">返回</div>
                                </div>
                            </FormItem>
                        </Form>
                    </Col>
                </Row>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data()
        {
            return {
                isSubmiting: false,
                form: {
                    version: '',   //版本
                    android: '',    //安卓路径
                    ios: '',    //ios地址,
                    describe: '',  //描述
                }
            };
        },
        mounted()
        {
            this.pageParam = this.$route.query;
			if(this.pageParam.id != undefined) {
				this.getDetail();
			}
        },
        methods: {
            handleBack()
            {
                this.$router.go(-1);
            },
            getDetail()
            {
                this.isSubmiting = true;
                this.$Rq.requestAuth({
                    url: this.$Api.versionEdit + '/' + this.pageParam.id,
                    method: 'get',
                }).then((res) =>{
                    this.isSubmiting = false;
                    if (res.code == 0){
                        let resData = res.data;
                        this.form = {
                            version: resData.version,
                            android: resData.android,
                            ios: resData.ios,
                            describe: resData.describe,
                        };
                    }
                }).catch((err) =>{
                    this.isSubmiting = false;
                });
            },
            handleCheckForm()
            {
                let form = this.form;
                if (form.version === '')
                {
                    this.$Utils.showTipInfo('請輸入版本');
                    return;
                } else if (form.android === '')
                {
                    this.$Utils.showTipInfo('請輸入Android下載地址');
                    return;
                } else if (form.ios === '')
                {
                    this.$Utils.showTipInfo('請輸入IOS下載地址');
                    return;
                }
				this.handleSubmit();
            },
            handleSubmit()
            {
				let describe = this.$refs.textValue.value.replace(new RegExp("\n","gm"),'<br/>');
                let form = this.form;
                this.isSubmiting = true;
				if(this.pageParam.id != undefined) {
					this.$Rq.requestAuth({
					    url: this.$Api.versionEdit + '/' + this.pageParam.id,
					    method: 'post',
					    data: {
					        version: form.version,
					        android: form.android,
					        ios: form.ios,
					        describe: form.describe,
					    }
					}).then((res) => {
					    this.isSubmiting = false;
					    if (res.code == 0) {
					        this.$Utils.showSuccess(res.msg);
					    } else {
					        this.$Utils.showTipInfo(res.msg);
					    }
					}).catch((err) =>{
					    this.isSubmiting = false;
					});
				} else {
					this.$Rq.requestAuth({
					    url: this.$Api.versionEdit,
					    method: 'post',
					    data: {
					        version: form.version,
					        android: form.android,
					        ios: form.ios,
					        describe: form.describe,
					    }
					}).then((res) => {
					    this.isSubmiting = false;
					    if (res.code == 0) {
					        this.$Utils.showSuccess(res.msg);
					    } else {
					        this.$Utils.showTipInfo(res.msg);
					    }
					}).catch((err) =>{
					    this.isSubmiting = false;
					});
				}
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import "VersionEdit.scss";
</style>